import { Redirect, Route, Switch } from 'react-router-dom';

import B2B2CSelector from '../pages/b2c-b2b-selector/Selector';
import Login from '../pages/login/Login';
import PrivateRoute from './PrivateRoute';
import * as path from './paths';

const Routes = () => (
    <Switch>
        <Route exact path={path.ROUTE_LOGIN} component={Login} />
        <PrivateRoute exact path={path.ROUTE_B2B_B2C_SELECTOR} component={B2B2CSelector} />
        <Redirect to={path.ROUTE_LOGIN} />
    </Switch>
);

export default Routes;
